define('sentient/aba/GaugeVertical',[
	'require',
	'jquery',
	'underscore',
	'loglevel',
	'domReady',
	'jquery.color'
], function(require, $, _, log, domReady, jqueryColor) {
	log.trace('GaugeVertical.js');
	return function(elements) {
		var $elements = $(elements);

		$elements.each(function(index, element) {
			var $element = $(element);
			$element.data({
				'knob': $element.find('.knob:first'),
				'maskTop': $element.find('.mask.top:first'),
				'maskBottom': $element.find('.mask.bottom:first'),
				'top-symbol': $element.find('.symbol.top').first(),
				'bottom-symbol': $element.find('.symbol.bottom').first(),
				'top-color': $.Color('#88dd16'),
				'center-color': $.Color('#3c454f'),
				'bottom-color': $.Color('#de4a3c')
			});

			$element.on('change', $.proxy(function($event, newValue, render) {
				var $this = $(this);
				var knob = $this.data('knob') || $this.find('.knob:first');
				var maskTop = $this.data('maskTop') || $this.find('.mask.top:first');
				var maskBottom = $this.data('maskBottom') || $this.find('.mask.bottom:first');
				//log.debug('newValue', newValue);
				//log.debug("top",(100 - ((newValue+1)*50)).toString() + "%");
				var newValuePercent = (100 - ((newValue + 1) * 50));
				knob.css({'top': newValuePercent.toString() + '%'});
				//log.debug('(Math.abs(newValuePercent-50))', (50 -  Math.abs(newValuePercent-50)));
				var newColor = null;
				if (newValue >= 0) {
					newColor = $this.data('center-color').transition($this.data('top-color'), Math.abs(newValue));
					knob.css({ 'background': newColor.toHexString() });
					knob.toggleClass('refresh');
					$this.data('top-symbol').css({'color': newColor.toHexString()});
					$this.data('bottom-symbol').css({'color': ''});
					maskBottom.css({ 'top': '' });
					maskTop.css({ 'bottom': (50 + Math.abs(newValuePercent - 50)).toString() + '%' });
				} else {
					newColor = $this.data('center-color').transition($this.data('bottom-color'), Math.abs(newValue));
					knob.css({ 'background': newColor.toHexString() });
					knob.toggleClass('refresh');
					$this.data('bottom-symbol').css({'color': newColor.toHexString()});
					$this.data('top-symbol').css({'color': ''});
					maskTop.css({ 'bottom': '' });
					maskBottom.css({ 'top': (50 + Math.abs(newValuePercent - 50)).toString() + '%' });
				}

			},element));
		});

	};
});

